import React from 'react'
import styled from 'styled-components'
import { Flex } from '@mprolab/uikit'
import MainWrapper from 'layouts/MainWrapper'
import TokenCard from 'components/TokenCard'
import Tokenomics from 'components/Tokenomics'

/**
 * The MPRO tab. The tokenomics chart used to be the whole page, which left the
 * token itself undocumented: no contract address, no live supply, no burn, no
 * emission. The card answers those first; the chart still explains how the
 * supply was allocated.
 */
const CardWrapper = styled(Flex)`
  width: 100%;
  /* Clears the fixed header, the same offset every other page uses. */
  padding: 152px 0 0;
`

const Mpro: React.FC = () => {
  return (
    <>
      <MainWrapper>
        <CardWrapper>
          <TokenCard />
        </CardWrapper>
      </MainWrapper>
      <Tokenomics />
    </>
  )
}

export default Mpro
